import React, { useEffect, useState } from "react";
import { Button, Form, Card } from "react-bootstrap";
import specialtyList from "../data/specialty";
import { useDispatch, useSelector } from "react-redux";
import { createClinic } from "../actions/clinicActions";
import Message from "./Message";
import { LIST_USER_CLINICS_RESET } from "../constants/clinicConstants";
import { RiSendPlaneFill } from "react-icons/ri";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { FaBuilding } from "react-icons/fa";
import { AiOutlineSend } from "react-icons/ai";

const ClinicForm = () => {
  const [clinicName, setClinicName] = useState("");
  const [specialtyId, setSpecialtyId] = useState("");
  const [bestClinicId, setBestClinicId] = useState("");
  const [selected, setSelected] = useState([]);
  const [message, setMessage] = useState("");

  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const clinicAddStore = useSelector((state) => state.clinicAddStore);
  const { newClinic, error } = clinicAddStore;

  useEffect(() => {
    if (selected.length > 0) {
      const selectedOption = selected[0];
      setSpecialtyId(selectedOption._id);
      setBestClinicId(selectedOption.bestClinicId || "");
    }
  }, [selected]);

  useEffect(() => {
    setMessage(error);
  }, [error]);

  // Submit form
  const submitHandler = () => {
    if (!clinicName || !specialtyId) {
      alert("Please fill in all fields.");
      return;
    }

    dispatch(
      createClinic({
        clinicName,
        specialtyId,
        bestClinicId,
        clinicOwnerId: userInfo._id,
        members: [
          {
            memberId: userInfo._id,
            permissionId: "0",
          },
        ],
      }),
    );
  };

  // Reset form after successful creation
  useEffect(() => {
    if (newClinic) {
      dispatch({ type: LIST_USER_CLINICS_RESET });
      setClinicName("");
      setSpecialtyId("");
      setBestClinicId("");
    }
  }, [newClinic, dispatch]);

  return (
    <Card className="border-primary p-4">
      <Form className="mx-4 my-2">
        <Form.Group controlId="clinicName">
          <Form.Label>Clinic Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter Clinic Name"
            value={clinicName}
            onChange={(e) => setClinicName(e.target.value)}
            isValid={clinicName}
          />
        </Form.Group>

        <Form.Group controlId="specialtyId">
          <Form.Label>Specialty</Form.Label>

          <Typeahead
            placeholder="Select your specialty"
            options={specialtyList}
            onChange={(e) => setSelected(e)}
            id="specialty-typeahead"
            className="flex-grow-1"
            isValid={selected.length > 0}
          />
        </Form.Group>
        {error && <Message variant="danger" children={error} />}

        <Form.Group className="text-right">
          <Button onClick={submitHandler} variant="outline-success">
            Send <AiOutlineSend />
          </Button>
        </Form.Group>
      </Form>
    </Card>
  );
};

export default ClinicForm;
